import FilledButton from "../../../component/FilledButton";

const CopyEventPop = ({ handleOpenModal, handleCopyCourse }) => {
    return (
        <div className="modal_body copy_course_modal">
            <div className="attached_courses-alert delete-pop">
                <h2>copy a event</h2>
                <p className="text_center">You are about to copy a event with its content. However, no users subscribed to this event will be transferred over. You may add users to the new event via UPLOAD USER button.</p>
                <p className="desc">Do you want to proceed?</p>
                <div className="action">
                    <FilledButton onClick={() => handleOpenModal()} value="no" className="btn btn_gray" />
                    <FilledButton onClick={() => { handleCopyCourse() }} value="yes" className="btn btn_primary" />
                </div>
            </div>
        </div>
    )
};

export default CopyEventPop;